export default __webpack_public_path__ + "static/footer-bg-img-6ea3ada211af7da24a77387c86af88e6.png";